module.exports = "/fonts/ElevanceSans-Bold.8183acdbc269e9d72bce2b7304f8edb0.woff";